<app-ui-progress-bar type="vpr" [value]="vpr" [vprScore]="vprOption"></app-ui-progress-bar>
